import axios from "axios";
import { getUnitApiBaseFour, SUB_URL, SUB_URL_GSM } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const ManageBinService = {
  add_bin: async (formValues) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_name", formValues.bin_name || "");
      formData.append("bin_capacity", formValues.bin_capacity || "");
      formData.append("bin_status", formValues.bin_status || "");
      formData.append("bin_added_by", formValues.bin_added_by || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.add_bin}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error adding bin:", error);
      return [];
    }
  },

  getBinData: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_bins}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching bin data:", error);
      return [];
    }
  },

  getGSMBinData: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_GSM.getGSMBin}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching GSM bin data:", error);
      return [];
    }
  },
};

export default ManageBinService;